export default "__VITE_ASSET__VPD7Fpzo__"